/* eslint-disable arrow-body-style */

import React from 'react';
import classnames from 'classnames';
import Loading from '@gp/components/Loading';
import GRActionItem from './Item';

import type { IBaseProps } from '@home/types/common';
import type { IGRActionItemVO } from '@gp/types/projectUpdate';

import './index.scss';

interface IGRActionItemsProps extends IBaseProps {
  isShowInitialTips?: boolean;
  isLoading?: boolean;
  isEmpty?: boolean;
  isError?: boolean;
  list?: IGRActionItemVO[] | null;
  onDelete?: (index: number) => void;
  onChange?: (index: number, payload: Partial<IGRActionItemVO>) => void;
}

const GRActionItems: React.FC<IGRActionItemsProps> = (props) => {
  const {
    style,
    className,
    isShowInitialTips,
    isLoading,
    isEmpty,
    isError,
    list,
    onDelete,
    onChange,
    actionItemCategory,
  } = props;

  return (
    <div
      style={style}
      className={classnames('dbg-gr-action-items', className, {
        'is-empty': isEmpty,
        'is-error': isError,
      })}
    >
      {isShowInitialTips && (
        <div className="dbg-gr-action-items__state-wrapper dbg-gr-action-items__no-initial">
          <span>Please select Time Period</span>
        </div>
      )}
      {!isShowInitialTips && isLoading && (
        <div className="dbg-gr-action-items__state-wrapper dbg-gr-action-items__loading">
          <Loading loading loadingText="Auto-synchronizing..." />
        </div>
      )}
      {!isShowInitialTips && !isLoading && isEmpty && (
        <div className="dbg-gr-action-items__state-wrapper dbg-gr-action-items__no-data">
          <span>No Data</span>
        </div>
      )}
      {!isShowInitialTips && !isLoading && !isEmpty && (
        <div className="dbg-gr-action-items__list">
          <div className="dbg-gr-action-items__list-tips">Outstanding GR Action Items</div>
          {list?.map((item, index) => {
            return (
              <div key={index} className="dbg-gr-action-items__item">
                <GRActionItem
                  index={index}
                  data={item}
                  onDelete={() => {
                    onDelete?.(index);
                  }}
                  actionItemCategory={actionItemCategory}
                  onChange={(payload) => {
                    onChange?.(index, payload);
                  }}
                />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default GRActionItems;
